export const SPECIE_NAMES_LIST = [
  'Eucalipto',
  'Pinus',
  'Cedro Australiano',
  'Mogno Africano',
  'Teca',
] as const;

export type SpecieName = typeof SPECIE_NAMES_LIST[number];
